import React from 'react';
import { ThemeProvider, Box } from '@mui/material';
import theme from 'styles/motoTheme';
import '../pages/inspection-momo/moto.css';
import { useThemeContext } from 'contexts/ThemeContext';

const AppLayout = ({ children }) => {
  const { mainColor, textColor } = useThemeContext();
  return (
    <ThemeProvider theme={theme({ mainColor, textColor })}>
      <main style={{ overflow: 'hidden' }}>
        <Box sx={{ backgroundColor: '#F9F9F9', overflow: 'hidden' }}>{children}</Box>
      </main>
    </ThemeProvider>
  );
};

export default AppLayout;
